import { SendcloudCarrierContract } from "@redotech/redo-fulfillment-rate-common/carrier-account";
import * as z from "zod";

export const listSendcloudContracts = {
  name: "listSendcloudContracts" as const,
  input: z.null(),
  output: z.object({ contracts: z.array(SendcloudCarrierContract) }),
};
